export class MicrosoftClient {
  constructor(apiUrl) {
    // Set Microsoft URL
    this.microsoftUrl = `${apiUrl}/microsoft`;
  }

  login() {
    const url = `${this.microsoftUrl}/login`;

    // Redirect to Microsoft login
    window.location.href = url;
  }

  logout() {
    const url = `${this.microsoftUrl}/logout`;

    // Redirect to Microsoft logout
    window.location.href = url;
  }
}



// WEBPACK FOOTER //
// ./src/clients/BackendAdminClient/microsoft.js